import { OverlayTrigger, Tooltip } from "react-bootstrap";

export const InfoTile = ({ label, value }) => (
  <div className="info-tile">
    <div className="small mb-1">{label}</div>
    <div className="info-value">{value}</div>
  </div>
);

export const SiteEntityTile = ({ label, entityName = '', onSwitch, maxLength= 36, disabled = false }) => {
  const isLong = entityName.length > maxLength;
  const valueNode = (
    <div className="info-value">
      {isLong ? `${entityName.slice(0, maxLength)}…` : entityName}
    </div>
  );
  return (
    <div className="info-tile">
      <div className="small mb-1">{label}</div>
      {isLong ? (
        <OverlayTrigger
          placement="top"
          overlay={
            <Tooltip id="entity-name-tooltip">
              {entityName}
            </Tooltip>
          }
        >
          {valueNode}
        </OverlayTrigger>
      ) : (
        valueNode
      )}
      {!disabled && (<span className="switch-btn" onClick={onSwitch}>⇄</span>)}
    </div>
  );
};
